export default {
    trust: {
        label: 'Trust',
        columnTitle: 'Trust',
        placeholder: 'Enter Trust (0-1)',
        required: 'Trust is required',
        range: 'Trust must be between 0 and 1 with 2 decimal places',
        reason: 'Reason',
        reasonRequired: 'Please enter a reason',
        reasonPlaceholder: 'Explain why Trust is being changed',
        edit: 'Edit Trust',
        filter: {
            all: 'All Trust',
            notDefault: 'Trust ≠ 1',
        },
        summary: 'Trust ≠ 1 on this page: {count}',
        updateSuccess: 'Trust updated',
        updateFailed: 'Failed to update Trust',
        editActorTitle: 'Edit Actor Trust',
        editUserTitle: 'Edit User Trust',
    },
};
